export default __webpack_public_path__ + "static/media/2.540d2849.png";